'use strict';

angular.module('licensure.services')
    .factory('ApplicationTypes', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ApplicationTypes', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (application_type, license_id) {
                var d = $q.defer();
                var method = 'POST';
                var url = apiLocation + '/api/ApplicationTypes/';
                if (!isUndefined(application_type.id)) {
                    method = 'PUT'
                    url += application_type.id;
                }
                else { // no post method
                    return $q.resolve(false);
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        application_type: application_type,
                        label: application_type.label,
                        license_id: license_id,
                        license_category_levels: application_type.license_category_levels
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;